import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { AppService, CoreTypes, FormValidatorService, LabelValue, Modal, SharedCommonService } from 'common-cloudstudio';
import { GearAppService, GearProxyService, GearTypes } from 'common-gear';
import { Subscription } from 'rxjs';
declare const environment;

@Component({
  selector: 'app-modal-change-value-endpoints',
  templateUrl: './modal-change-value-endpoints.component.html',
  styleUrls: ['./modal-change-value-endpoints.component.scss']
})
export class ModalChangeValueEndpointsComponent implements OnInit, OnDestroy {
  @ViewChild('formElement') public _formElement: NgForm;
  @ViewChild("securityModal") private _securityModal: Modal;
  @Input() actions?: GearTypes.GearDisplayClusterAction;
  @Output() public ExecComplete = new EventEmitter<void>();

  actions2:any;

  _subscriptions: Subscription[] = [];
  _errorMessageAuth: string;
  valueWithUnits: CoreTypes.ValueWithUnits = new CoreTypes.ValueWithUnits();
  changeValue: number = 0;
  changeValueText: string = '';
  unitValue: LabelValue<number>;
  actionId: any = 0;
  actionType: number = 0;
  discreteValue: LabelValue<number>;
  pageStatus: number = 0;
  _loginTypeSelected: CoreTypes.LoginType;
  _token: string;
  password: string = null;
  discreteValueList: LabelValue<number>[] = new Array<LabelValue<number>>();
  unitValueList: LabelValue<number>[] = new Array<LabelValue<number>>();
  hidePassword: boolean = false;
  _isAvailableLoginTypeAuth0: boolean;
  _isAvailableLoginTypeBuiltin: boolean;
  endpointID: number = 0;
  actionEndpointId: string = '';
  alertInfoUnitValue: string = '';
  endpointType: number= 0;
  component: string = '';
  isChecked: boolean = false;
  editModeLoading: boolean = false;
  actionComponent?: GearTypes.GearDisplayClusterAction;
  displayClusterActionType = {
    Simple: GearTypes.GearDisplayClusterActionType.Simple, 
    HorizontalSlider: GearTypes.GearDisplayClusterActionType.HorizontalSlider, 
    VerticalSlider: GearTypes.GearDisplayClusterActionType.VerticalSlider, 
    WatchVideoFeed: GearTypes.GearDisplayClusterActionType.WatchVideoFeed, 
    SetScalarValue: GearTypes.GearDisplayClusterActionType.SetScalarValue, 
    SetDiscreteValue: GearTypes.GearDisplayClusterActionType.SetDiscreteValue
  }

  useOfflineMode: boolean = false;

  constructor(
    public _appService: AppService,
    private _formValidatorService: FormValidatorService,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    private router: Router,
    public _route: ActivatedRoute,
    public _auth0: AuthService,
    public sharedCommonService: SharedCommonService,
  ) {
    this.useOfflineMode = environment.useOfflineMode;
    this._route.params.subscribe((event) => {
      if (+event["endpointId"]) {
        this.endpointID = +event["endpointId"];
        this.actionEndpointId = 'Endpoint.'+ this.endpointID;
      }
      if (+event["endpointType"]) {
        this.endpointType = event["endpointType"];
      }
      if (event["component"]) {
        this.component = event["component"];
        if (this.component == 'view'){
          this.actionComponent = this._appService.actionsViews;
        }else if (this.component == 'device'){
          this.actionComponent = this._appService.actionsDevices;
        }
      }
    });
   }

  async ngOnInit() {
    await new Promise(resolve => { setTimeout(() => resolve(null), 100); });
    this._subscriptions.push(this._gearAppService.onGearPermissionsSet.subscribe(() => {
      this.setSetteings();
      this.setActions(this.actionComponent)
    }));
    if (this._appService.CoreCommonLiterals && this._gearAppService.GearMonitorLiterals) {
      this.setSetteings();
      this.setActions(this.actionComponent)
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  setSetteings() {
    let settings = this._appService.onStartingSettings.getValue()?.startingSettings;
    this._isAvailableLoginTypeAuth0 = settings?.LoginTypeAvailables?.includes(CoreTypes.LoginType.Auth0);
    this._isAvailableLoginTypeBuiltin = settings?.LoginTypeAvailables?.includes(CoreTypes.LoginType.Builtin);
  }

  async setActions(actions){
    if(!actions) return;
    this.actions = actions;
    this.actionId = actions?.ActionID ? actions.ActionID : 0;
    this.actionType = actions?.ActionType ? actions.ActionType : 0;
    await this.setValueSecurityEndpoint();
  }

  modalExecuteAction() {
    if (this._formElement && !this._formElement.form.valid) {
      this._errorMessageAuth = this._formValidatorService.getValidationErrors(this._formElement);
      return;
    }
    switch (this.actions?.ActionType) {
      case this.displayClusterActionType.SetScalarValue:
        this.valueWithUnits.Value = this.changeValue;
        this.valueWithUnits.Units = this.unitValue?.label ? this.unitValue.label : '';
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
        break;
      case this.displayClusterActionType.SetDiscreteValue:
        this.valueWithUnits.Value = this.discreteValue?.value;
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
        break;
      case this.displayClusterActionType.Simple:
        this.actions.CurrentValue !== null ? this.valueWithUnits.DisplayValue = this.changeValueText : this.valueWithUnits.Value = this.actionType;
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
        break;
      default:
        this.valueWithUnits.Value = this.actionType;
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
        break
    }
  }

  execAction(id, actionType, value) {
    this.pageStatus = 0;
    if(!this._securityModal.isOpened) {
      this._appService.startLoading();
    }
    let parameters: GearTypes.GearDisplayClusterActionParameters = new GearTypes.GearDisplayClusterActionParameters();
    parameters.Value = value;
    this._gearProxyService.RealTimeDataService.ExecuteAction2(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      id,
      parameters,
      this.createLoginRequest(),
      () => {
        // Emitir evento para informar la ejecucion exitosa.
        this.pageStatus = 1;
        this.ExecComplete.next();
        this._appService.stopLoading();
        this._appService.actionsViews = null;
        this._appService.actionsDevices = null;
        this.sharedCommonService.onConfirmOperationChangeValue.next(true);
        this._securityModal.close();
      },
      (error) => {
        this.pageStatus = 2;
        this._errorMessageAuth = error.Message;
        if(!this._securityModal.isOpened) {
          this._appService.stopLoading();
          this._appService.actionsViews = null;
          this._appService.actionsDevices = null;
          this.sharedCommonService.onConfirmOperationChangeValue.next(false);
          this._appService.showException(error);
        }
      }
    );
  }

  createLoginRequest() : CoreTypes.LoginRequest {
    let request = new CoreTypes.LoginRequest();
    request.LoginType = this._loginTypeSelected;

    if(this._loginTypeSelected == CoreTypes.LoginType.Builtin)
      request.Password = this.password;
    else
      request.Token = this._token;

    return request;
  }

  close() {
    /* this.cameraSnapshots.CameraSnapshotID = 0; */
    this.sharedCommonService.onConfirmOperationChangeValue.next(false);
    setTimeout(() => this.router.navigate([{outlets: { modal: null}}]), 200);
  }

  async setValueSecurityEndpoint() {
    await this.getDiscreteValues();
    if (this.actions?.ActionType === this.displayClusterActionType.SetScalarValue && (this.actions.CurrentValue !== null)) {
      this.changeValue = this.actions.CurrentValue.Value;
      let optionsList: LabelValue<number>[] = [];
      this.actions.CurrentValue.AllowedUnits.forEach((x, i)=> {
        const item = {
          label: x,
          value: i,
        };
        optionsList.push(item);
      })
      this.unitValueList = optionsList;
      if (this.actions.CurrentValue.Units) {
        setTimeout(() => {
          this.unitValue = this.unitValueList.find((x) => x.label === this.actions.CurrentValue.Units);
        }, 100);
      } else {
        this.unitValue = this.unitValueList[0];
      }
      setTimeout(() => {
        this.alertInfoUnitValue = this.unitValue?.label;
      }, 200);
    }
    
    if (this.actions?.ConfirmationMessage || this.actions?.RequiresPasswordConfirmation ||
      this.actions?.ActionType === this.displayClusterActionType.SetScalarValue ||
      this.actions?.ActionType === this.displayClusterActionType.SetDiscreteValue ||
      (this.actions?.ActionType === this.displayClusterActionType.Simple && (this.actions.CurrentValue !== null)))
    {
      this._errorMessageAuth = '';
      this.pageStatus = 1;
      if(this.actions?.ActionType === this.displayClusterActionType.Simple && (this.actions.CurrentValue !== null)) {
        this.changeValueText = this.actions.CurrentValue.DisplayValue;
      }
      if (this.actions?.RequiresPasswordConfirmation) {
        this.requestCredential();
      } else {
        setTimeout(() => {
          this.password = '';
          this._securityModal.open();
        }, 100);
      }
    } else {
      this.valueWithUnits.Value = this.actionType;
      if (this.actionId && this.actionType && this.valueWithUnits ){
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
      } else{
        setTimeout(() => {
          this.password = '';
          this.close();
        }, 300);
        this.execAction(this.actionId, this.actionType, this.valueWithUnits);
      }
    }
  }

  getDiscreteValues() {
    if (this.actions?.AllowedValues) {
      let optionsList: LabelValue<number>[] = [];
      this.actions.AllowedValues.forEach(x => {
        const item = {
          label: x.Description,
          value: x.Value,
        };
        optionsList.push(item);
      })
      this.discreteValueList = optionsList;
      if(this.actions.CurrentValue !== null) {
        setTimeout(() => {
          this.discreteValue = this.discreteValueList.find((x) => x.value === this.actions.CurrentValue.Value);
        }, 100);
      } else {
        this.discreteValue = this.discreteValueList[0];
      }
    }
  }

  requestCredential() {
    let settings = this._appService.onStartingSettings.getValue()?.startingSettings;
    if (settings?.LoginTypeAvailables.length == 0)
      throw "There is no login available";

    if (settings?.LoginTypeAvailables.length == 1) {
      if (!this.useOfflineMode && this._isAvailableLoginTypeAuth0){
        this._loginTypeSelected = CoreTypes.LoginType.Auth0;
        this.hidePassword = true;
        this._subscriptions.push(this._auth0.loginWithPopup({prompt: 'login'}, {timeoutInSeconds: 360}).subscribe(() => {
          setTimeout(() => {
            this.password = '';
            this._subscriptions.push(this._auth0.getAccessTokenSilently().subscribe((token) => {
              this._token = token;
            }));

            this._securityModal.open();
          }, 100);
        }, _ => {}));
      } else if (this._isAvailableLoginTypeBuiltin) {
        this._loginTypeSelected = CoreTypes.LoginType.Builtin;
        this.hidePassword = false;
        setTimeout(() => {
          this.password = '';
          this._securityModal.open();
        }, 100);
      }
    } else {
      this._loginTypeSelected = CoreTypes.LoginType.Builtin;
      this.hidePassword = false;
      setTimeout(() => {
        this.password = '';
        this._securityModal.open();
      }, 100);
    }
  }
}
